import { render, staticRenderFns } from "./nr-project-edit.vue?vue&type=template&id=3bb97a8f&scoped=true"
import script from "./nr-project-edit.vue?vue&type=script&lang=ts"
export * from "./nr-project-edit.vue?vue&type=script&lang=ts"
import style0 from "./nr-project-edit.vue?vue&type=style&index=0&id=3bb97a8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb97a8f",
  null
  
)

export default component.exports